<template>
  <div
    v-if="hctUserRewardInfo"
    class="myLottery"
  >
    <div class="myLottery-header">
      <div class="myLottery-header__bank">
        <div
          class="myLottery-header__logo"
          :style="{backgroundImage: 'url('+currentBankInfo.bankIcon+')'}"
        ></div>
        <div class="myLottery-header__bankName">
          {{ currentBankInfo.bankName }}
        </div>
        <div class="myLottery-header__bless">
          祝你
        </div>
      </div>
      <div class="myLottery-header__greeting">
        {{ greeting }}
      </div>
    </div>
    <div
      v-if="singleRewardInfo && singleRewardInfo.length>0"
      class="myLottery-content"
    >
      <div
        v-for="(item, index) in singleRewardInfo"
        :key="index"
        class="myLottery-content__item"
      >
        <div
          v-if="item.rewardType==='ACCESSORY' && profilePhoto"
          class="myLottery-content__img avatar"
          :style="{backgroundImage: 'url('+profilePhoto+')'}"
        >
          <div
            v-if="transToObj(item.rewardPicture) && transToObj(item.rewardPicture).dynamic"
            class="myLottery-content__img--ornament"
          >
            <phtot-lottie
              :dynamicDef="'photoAni'+index"
              :lottiePath="transToObj(item.rewardPicture).dynamic"
            ></phtot-lottie>
          </div>
        </div>
        <div v-else>
          <div
            v-if="transToObj(item.rewardPicture) && transToObj(item.rewardPicture).static"
            class="myLottery-content__img"
            :style="{backgroundImage: 'url('+transToObj(item.rewardPicture).static+')'}"
          ></div>
        </div>
        <div class="myLottery-content__name">
          {{ item.rewardName }}
        </div>
        <div
          class="myLottery-content__guide"
          @click="toGuide(item.rewardType)"
        >
          {{ guideInfo(item.rewardType) }}</div>
        <div
          :class="['myLottery-content__btn', {'disabledBtn': (item.rewardType==='ACCESSORY' && item.rewardStatus !== 2)}]"
          @click="handleBtn(item.rewardType, item.rewardStatus, item.ext)"
        >
          {{ btnText(item.rewardType, item.rewardStatus) }}</div>
      </div>
    </div>
    <basic-modal
      :visible.sync="showModal"
      :modalMessage="modalMessage"
      @onConfirm="toBindWalletGuide"
    >
    </basic-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { monitor } from '@/common/monitor';
import { lx } from '@/analytic/index';
import { lxConfig } from '@/analytic/profilePhoto';
import { env } from '@/common/env';
import { lotteryActivityId } from '@/common/config';
import { bankInfo } from '../config/bankInfo';
import BasicModal from './BasicModal.vue';
import PhtotLottie from './PhototLotttie.vue';

Vue.use(Toast);

export default {
  components: {
    BasicModal,
    PhtotLottie
  },
  props: {
    hctUserRewardInfo: {
      type: Object,
      default: () => {}
    },
    appPortrait: {
      type: String,
      default: ''
    },
    portraitStatus: {
      type: Boolean,
      default: false
    },
    lotteryCount: {
      type: String,
      default: ''
    },
    cityCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bankInfo,
      showModal: false
    };
  },
  computed: {
    profilePhoto() {
      return this.appPortrait || 'https://p0.meituan.net/wxapp/c6a436105a62d7a8029cbd46609f13c44783.png';
    },
    currentBankInfo() {
      return bankInfo[this.hctUserRewardInfo && this.hctUserRewardInfo.bankTypeId] || {};
    },
    modalMessage() {
      return {
        title: '限数字人民币用户专享',
        message: '需按下方步骤完成数字人民币开通，<span class="highlight">无需拥有对应银行卡</span>',
        btnText: '查看开通步骤'
      };
    },
    singleRewardInfo() {
      const arr = (this.hctUserRewardInfo && this.hctUserRewardInfo.singleRewardInfos) || [];
      let temp;
      const res = [];
      arr.forEach((item) => {
        if (item.rewardType === 'ACCESSORY') {
          // 将头像挂饰奖励放在前面
          res.unshift(item);
        } else if (item.rewardType === 'REDPCT') {
          // 邮储返回3个权益时候，不展示红包的权益
          temp = item;
        } else {
          res.push(item);
        }
      });
      if (res.length < 2 && temp) {
        res.push(temp);
      }
      return res;
    },
    greeting() {
      const greetings = this.singleRewardInfo.filter((item) => item.greetings) || [];
      return greetings[0] && greetings[0].greetings;
    }
  },
  methods: {
    transToObj(rewardPicture) {
      if (!rewardPicture || Object.prototype.toString.call(rewardPicture) === '[object Object]') {
        return rewardPicture;
      }
      try {
        const obj = JSON.parse(rewardPicture);
        return obj || {};
      } catch (err) {
        console.log(err);
        monitor.captureMessage({
          name: '【好彩头】-转JSON对象失败',
          msg: JSON.stringify(err)
        }, {
          level: 'error'
        });
        return '';
      }
    },
    guideInfo(rewardType) {
      switch (rewardType) {
        case 'REDPCT': // 红包
          return '查看红包';
        case 'ACCESSORY': // 挂件
          return '查看头像攻略';
        case 'HD_WALLET': // 硬钱包
          return '查看兔卡攻略';
        case 'ONE_YUAN_PURCHASE': // 一元购
          return '查看使用攻略';
        case 'COUPON': // 现金券
          return '查看支付券';
        default:
          return '';
      }
    },
    btnText(rewardType, rewardStatus) {
      switch (rewardType) {
        case 'REDPCT': // 红包
          return '查看攻略';
        case 'ACCESSORY': // 挂件
          return '去佩戴';
        case 'COUPON': // 现金券
          return '查看攻略';
        case 'HD_WALLET': // 硬钱包
          if (rewardStatus === 2) {
            return '去查看';
          } else {
            return '去领取';
          }
        case 'ONE_YUAN_PURCHASE': // 一元购
          if (rewardStatus === 2) {
            return '去查看';
          } else {
            return '去购买';
          }
        default:
          return '';
      }
    },
    toGuide(rewardType) {
      let url;
      switch (rewardType) {
        case 'REDPCT': // 红包
          url = `${location.protocol}//${location.host}/ecny/home/index.html?from=haocaitou#/redPacket`;
          break;
        case 'ACCESSORY': // 挂件
          url = 'https://cube.meituan.com/cube/block/0bb53118604980e4bacc/211530/index.html';
          break;
        case 'HD_WALLET': // 硬钱包
          url = 'https://cube.meituan.com/cube/block/94a91187cc0c58a511d9/211533/index.html';
          break;
        case 'ONE_YUAN_PURCHASE': // 一元购
          url = 'https://cube.meituan.com/cube/block/8ed522df09e7e79944e9/211531/index.html';
          break;
        case 'COUPON': // 现金券
          url = `${location.protocol}//${location.host}/ecny/home/index.html?from=haocaitou#/coupon`;
          break;
        default:
          return '';
      }
      this.$bridge.openPage(url);
    },
    handleBtn(rewardType, rewardStatus, ext) {
      try {
        let url;
        let shoppingOrderNo;
        let goodsId;
        let decorationId;
        if (ext) {
          const extObj = JSON.parse(ext);
          shoppingOrderNo = extObj && extObj.shoppingOrderNo;
          goodsId = extObj && extObj.goodsId;
          decorationId = extObj && extObj.decorationId;
        }
        switch (rewardType) {
          case 'COUPON': // 现金券
            url = this.currentBankInfo && this.currentBankInfo.couponGuide;
            lx.addTag({
              c_fsp_dcep_j4pmca31: {
                bid: lxConfig.check_coupon_btn_mc
              }
            });
            this.lxMc(lxConfig.check_coupon_btn_mc);
            break;
          case 'REDPCT': // 红包
            url = this.currentBankInfo && this.currentBankInfo.redpctGuide;
            lx.addTag({
              c_fsp_dcep_j4pmca31: {
                bid: lxConfig.check_envelop_btn_mc
              }
            });
            this.lxMc(lxConfig.check_envelop_btn_mc);
            break;
          case 'ACCESSORY': // 挂件
            this.lxMc(lxConfig.to_wear_btn_mc);
            if (rewardStatus !== 2) {
              Toast('操作有些频繁，请稍后再试');
              this.$emit('refresh');
              return;
            } else {
              this.$emit('toDcepWear', decorationId);
              return;
            }
          case 'HD_WALLET': // 硬钱包
            lx.addTag({
              c_fsp_dcep_j4pmca31: {
                bid: lxConfig.hard_wallet_btn_mc
              }
            });
            this.lxMc(lxConfig.hard_wallet_btn_mc);
            if (rewardStatus === 0) {
              Toast('操作有些频繁，请稍后再试');
              this.$emit('refresh');
              return;
            } else {
              url = `${location.protocol}//${location.host}/ecny/hardwallet/rabbitAddress.html?from=${env.from}&orderNo=${shoppingOrderNo}&goodsId=${goodsId}&activityId=${env.actGroupName || lotteryActivityId}&cityId=${this.cityCode}`;
            }
            break;
          case 'ONE_YUAN_PURCHASE': // 一元购
            lx.addTag({
              c_fsp_dcep_j4pmca31: {
                bid: lxConfig.one_yuan_purchase_btn_mc
              }
            });
            this.lxMc(lxConfig.one_yuan_purchase_btn_mc);
            if (this.hctUserRewardInfo && this.hctUserRewardInfo.bindTokenStatus) {
              if (rewardStatus === 0) {
                this.$emit('refresh');
                Toast('操作有些频繁，请稍后再试');
                return;
              } else {
                url = `${location.protocol}//${location.host}/ecny/hardwallet/rabbitOneCoinPay.html?from=${env.from}&orderNo=${shoppingOrderNo}&goodsId=${goodsId}&activityId=${env.actGroupName || lotteryActivityId}&cityId=${this.cityCode}`;
              }
            } else {
              this.showModal = true;
              lx.mv(lxConfig.bind_wallet_modal_mv, {
                from: env.from || -999,
                activity_id: env.actGroupName || lotteryActivityId,
                bank_id: this.hctUserRewardInfo.bankTypeId || -999,
                city_id: this.cityCode || -999,
                page_status: this.lotteryCount || -999,
                user_status: this.portraitStatus ? 1 : 0
              }, {
                cid: lxConfig.index_pv
              });
              return;
            }
            break;
          default:
            return '';
        }
        this.$bridge.openPage(url);
      } catch (err) {
        monitor.captureMessage({
          name: '【好彩头】-跳转失败',
          msg: JSON.stringify(err)
        }, {
          level: 'info'
        });
      }
    },
    toBindWalletGuide() {
      this.lxMc(lxConfig.bind_wallet_guide_btn_mc);
      this.$bridge.openPage(this.currentBankInfo && this.currentBankInfo.guideLink);
    },
    lxMc(bid) {
      lx.mc(bid, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        bank_id: this.hctUserRewardInfo.bankTypeId || -999,
        city_id: this.cityCode || -999,
        page_status: this.lotteryCount || -999,
        user_status: this.portraitStatus ? 1 : 0
      }, {
        cid: lxConfig.index_pv
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../styles/fn.less";
.myLottery {
  .bg-image-auto('https://p1.meituan.net/wxapp/b4b6c0cbfeff11c904c761d0ed69bd3413446.png');
  width: 6.9rem;
  height: 4.75rem;
  margin: auto;
  position: relative;
  .myLottery-header {
    .bg-image-auto('https://p0.meituan.net/wxapp/d0559165449a5957d413e3016699852253488.png');
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -0.67rem;
    width: 6rem;
    height: 1.9rem;
    .myLottery-header__bank {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.41rem;
    }
    .myLottery-header__logo {
      width: 0.27rem;
      height: 0.27rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .myLottery-header__bankName {
      font-weight: 500;
      font-family: PingFangSC-Medium;
      font-size: 0.213rem;
      color: #FFFDE5;;
      text-align: right;
      margin: 0 0.06rem;
    }
    .myLottery-header__bless {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 0.194rem;
      color: #FFFDE5;
    }
    .myLottery-header__greeting {
      font-weight: 600;
      font-family: PingFangSC-Semibold;
      font-size: 0.32rem;
      color: #FFFDE5;
      letter-spacing: 0.117rem;
      text-align: center;
    }
  }
  .myLottery-content {
    padding-top: 1.25rem;
    display: flex;
    justify-content: center;
    width: 100%;
    .myLottery-content__item {
      flex: 1;
      margin: 0 auto;
      text-align: center;
      position: relative;
    }
    .myLottery-content__img {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 0.7rem;
      margin: auto;
      background-size: 100% auto;
      background-repeat: no-repeat;
      position: relative;
      background-position: center;
    }
    .avatar {
      background-size: 1.26rem auto;
    }
    .myLottery-content__img--ornament {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
      background-size: 100% auto;
      background-repeat: no-repeat;
      width: 1.6rem;
      height: 1.6rem;
    }
    .myLottery-content__name {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 0.236rem;
      color: #121212;
      text-align: center;
      margin-top: 0.15rem;
      width: 3.45rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .myLottery-content__guide {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 0.215rem;
      color: #3C72FA;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 1.92rem;
      margin: auto;
    }
    .myLottery-content__btn {
      margin: 0.51rem auto 0;
      .bg-image-auto('https://p0.meituan.net/wxapp/857132d380906c007034bf5057d89abb15173.png');
      width: 2.02rem;
      height: 0.7rem;
      line-height: 0.7rem;
      font-weight: 600;
      font-family: PingFangSC-Semibold;
      font-size: 0.258rem;
      color: #5D1B06;
      text-align: center;
    }
    .disabledBtn {
      color: rgba(0, 0, 0, 0.2);
      .bg-image-auto('https://p0.meituan.net/wxapp/259a2b9d2d5d39f2f5dfc42fca7d4ab74191.png');
    }
  }
}
</style>
